<form [formGroup]="formGroup" (submit)="saveChanges()" fxLayout="column" fxLayoutAlign="center center">
 
  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="close(false)" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ data?.handling_fee ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_HANDLING_FEE' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_HANDLING_FEE' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]=disableSaveBtn()>
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>
 
  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- company -->
    <esc-company-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="companySelected($event)"
      [previousData]="data"
      [requiredError]="companyRequired"
      [disabled]="isDisabled"
      >
    </esc-company-dropdown>

    <!-- handling_fee -->
    <div fxLayout>
      <mat-form-field>
        <input
          #handling_fee
          matInput
          required
          autocomplete="off" 
          formControlName="handling_fee" 
          [placeholder]="'LABEL_HANDLING_FEE' | translate"
          >

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>   

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('max')">
          {{ 'MSG_MAX' | translate: {quantity: '100'} }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('handling_fee').hasError('decimalErr')">
          {{ 'MSG_ERROR_DECIMAL_PLACES' | translate: {places: '2'} }}
        </mat-error> 
      </mat-form-field>
    </div>
 
    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>
  </div>
</form>